const CircleExclamationWhite = ({ className }: { className: string }) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <g id="icon / circle-exclamation">
      <path
        id="vector"
        d="M8 14C9.5913 14 11.1174 13.3679 12.2426 12.2426C13.3679 11.1174 14 9.5913 14 8C14 6.4087 13.3679 4.88258 12.2426 3.75736C11.1174 2.63214 9.5913 2 8 2C6.4087 2 4.88258 2.63214 3.75736 3.75736C2.63214 4.88258 2 6.4087 2 8C2 9.5913 2.63214 11.1174 3.75736 12.2426C4.88258 13.3679 6.4087 14 8 14ZM8 5C8.31172 5 8.5625 5.25078 8.5625 5.5625V8.1875C8.5625 8.49922 8.31172 8.75 8 8.75C7.68828 8.75 7.4375 8.49922 7.4375 8.1875V5.5625C7.4375 5.25078 7.68828 5 8 5ZM7.25 10.25C7.25 10.0511 7.32902 9.86032 7.46967 9.71967C7.61032 9.57902 7.80109 9.5 8 9.5C8.19891 9.5 8.38968 9.57902 8.53033 9.71967C8.67098 9.86032 8.75 10.0511 8.75 10.25C8.75 10.4489 8.67098 10.6397 8.53033 10.7803C8.38968 10.921 8.19891 11 8 11C7.80109 11 7.61032 10.921 7.46967 10.7803C7.32902 10.6397 7.25 10.4489 7.25 10.25Z"
        fill="white"
      />
    </g>
  </svg>
);

export default CircleExclamationWhite;
